var React = require('react');

function Show (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1.06152 8C1.06152 8 4.26152 2.5 9.06152 2.5C13.8615 2.5 17.0615 8 17.0615 8C17.0615 8 13.8615 13.5 9.06152 13.5C4.26152 13.5 1.06152 8 1.06152 8Z","stroke":"#4768EB","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M9.0612 10.5C10.534 10.5 11.7279 9.38071 11.7279 8C11.7279 6.61929 10.534 5.5 9.0612 5.5C7.58844 5.5 6.39453 6.61929 6.39453 8C6.39453 9.38071 7.58844 10.5 9.0612 10.5Z","stroke":"#4768EB","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Show.defaultProps = {"width":"18","height":"16","viewBox":"0 0 18 16","fill":"none"};

module.exports = Show;

Show.default = Show;
